// src/pages/CreateSharedConversation.jsx

import { useState } from "react";
import { useNavigate } from "react-router-dom";

const API_BASE = "http://localhost:4000";
//const API_BASE = "https://myjourneytrails.com";

export default function CreateSharedConversation() {
  const navigate = useNavigate();

  const [companionName, setCompanionName] = useState("");
  const [companionType, setCompanionType] = useState("remote");
  const [accessCode, setAccessCode] = useState("");
  const [userNote, setUserNote] = useState("");
  const [expiresAt, setExpiresAt] = useState(
    new Date(Date.now() + 2 * 60 * 60 * 1000).toISOString().slice(0, 16)
  );

  const [status, setStatus] = useState("");

  async function handleCreate(e) {
    e.preventDefault();
    setStatus("");

    const res = await fetch(`${API_BASE}/api/shared/create`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({
        companion_name: companionName,
        companion_type: companionType,
        access_code: accessCode,
        user_note: userNote,
        expires_at: new Date(expiresAt).toISOString()
      })
    });

    const data = await res.json();

    if (!res.ok) {
      setStatus(data.error || "Failed to create conversation");
      return;
    }

    navigate(`/shared/${data.token}`);
  }

  return (
    <div className="page-wrap">
      <h1>Create Shared Conversation</h1>

      <form className="form" onSubmit={handleCreate}>
        <label>Companion Name</label>
        <input
          value={companionName}
          onChange={(e) => setCompanionName(e.target.value)}
        />

        <label>Companion Type</label>
        <select
          value={companionType}
          onChange={(e) => setCompanionType(e.target.value)}
        >
          <option value="remote">Remote</option>
          <option value="inperson">In Person</option>
          <option value="friend">Friend</option>
          <option value="other">Other</option>
        </select>

        <label>Access Code</label>
        <input
          type="password"
          value={accessCode}
          onChange={(e) => setAccessCode(e.target.value)}
        />

        <label>Expires At</label>
        <input
          type="datetime-local"
          value={expiresAt}
          onChange={(e) => setExpiresAt(e.target.value)}
        />

        <label>Optional Note</label>
        <textarea
          value={userNote}
          onChange={(e) => setUserNote(e.target.value)}
        />

        {status && <div className="status">{status}</div>}

        <button type="submit">Create</button>
      </form>
    </div>
  );
}
